export const contactsData = {
    email: 'drsindhusha.gundlapally@gmail.com',
    phone: '+1 (510) 319-9738',
    sheetAPI: ''
}